<div *ngFor="let recipe of recipes">
  <div
    class="RecipeCard bg-light position-relative"
    [ngClass]="{ 'mb-3 cursor-pointer': isPromotedItem }"
    [ngStyle]="
      recipe.isAddedToCart && isPromotedItem
        ? {
            'background-color': ItemBackgroundColor,
            border: '2px solid #07ab39'
          }
        : { 'background-color': ItemBackgroundColor }
    "
  >
    <span
      class="position-absolute rounded-circle bg-white"
      style="top: -14px; right: -5px"
      *ngIf="recipe.isAddedToCart && isPromotedItem"
      ><i class="fa fa-check-circle fs-3 text-success" aria-hidden="true"></i
    ></span>
    <div class="d-flex">
      <div *ngIf="recipe?.RecipeImage && showImage" class="recipeImage br-10px">
        <img src="{{ recipe?.RecipeImage }}" alt="Recipe Image" />
      </div>
      <div class="ms-2 RecipeTitleContainer">
        <div class="recipe-Title-Des">
          <div>
            <h2
              class="mb-0"
              [ngStyle]="
                !recipe.RecipeStock
                  ? { color: 'lightgrey' }
                  : { color: ItemTitleColor }
              "
            >
              {{ recipe?.RecipeTitle }}
              <span *ngIf="recipe.IsNewlyAdded" id="New-Recipe">New</span>
              <span *ngIf="recipe.IsPopular" id="popular-Recipe">Popular</span>
              <span id="popular-Recipe" *ngIf="isPromotedItem">Free</span>
              <span *ngIf="!recipe.RecipeStock" class="text-danger">
                - {{ outOfStockLabelText || "Coming Soon" }}
              </span>
            </h2>
            <p class="recipeDesc" [ngStyle]="{ color: ItemDescriptionColor }">
              {{ recipe?.RecipeDescription }}
            </p>
          </div>
        </div>
        <div class="product-footer d-flex flex-wrap">
          <span
            class="text-custom-white square-tag"
            *ngFor="let allergen of recipe.Allergens"
          >
            <img src="{{ allergen }}" alt="tag" />
          </span>
        </div>
      </div>
    </div>
    <div class="price-Cart">
      <ng-container
        *ngIf="recipe.RecipeDiscountType && recipe.RecipeDiscountAmount"
      >
        <div class="d-flex justify-content-end">
          <span
            class="text-center rounded-3 py-1 px-3"
            [ngStyle]="{
              'background-color': RecipeDiscountLabelBGColor || '#198754',
              color: RecipeDiscountLabelTextColor || '#FFFFFF'
            }"
          >
            <p class="m-0">
              <!-- <i class="fa fa-gift"></i> -->
              <ng-container *ngIf="recipe.RecipeDiscountType === 'Percentage'">
                {{ recipe.RecipeDiscountAmount / 100 | percent: "1.0-2" }} OFF
              </ng-container>
              <ng-container *ngIf="recipe.RecipeDiscountType === 'Cash'">
                {{ recipe.RecipeDiscountAmount | currency: CurrencySymbol }} OFF
              </ng-container>
            </p>
          </span>
        </div>

        <small
          [ngStyle]="{ color: RecipeOldPriceTextColor || '#696868' }"
          *ngIf="recipe.RecipeOldPrice"
        >
          {{ RecipeOldPriceText || "Before" }}
          <s>{{ recipe.RecipeOldPrice | currency: CurrencySymbol }}</s>
        </small>
      </ng-container>

      <span
        (click)="
          recipe.RecipeStock && addTocart && !recipe.isAddedToCart
            ? getRecipeModal(recipe)
            : ''
        "
        *ngIf="!recipe?.DisplayAmountText?.trim()?.length"
        style="border-radius: 40px; padding: 5px; font-size: large"
        [ngStyle]="{
          color: RecipePriceTextColor,
          border: '1px solid' + RecipePriceBorderColor,
          'background-color': RecipePriceBackgroundColor
        }"
      >
        <span
          *ngIf="recipe.RecipeDiscountType && recipe.RecipeDiscountAmount"
          >{{ RecipeNewPriceText || "Now" }}</span
        >
        <span *ngIf="!isPromotedItem">
          {{
            recipe?.RecipePrice | currency: CurrencySymbol : "symbol" : "1.2-2"
          }}
        </span>

        <span *ngIf="isPromotedItem">
          {{ 0 | currency: CurrencySymbol : "symbol" : "1.2-2" }}
        </span>
      </span>

      <span *ngIf="isPromotedItem">
        <s>{{
          recipe?.RecipePrice | currency: CurrencySymbol : "symbol" : "1.2-2"
        }}</s>
      </span>

      <span
        class="price"
        (click)="
          recipe.RecipeStock && addTocart && !recipe.isAddedToCart
            ? getRecipeModal(recipe)
            : ''
        "
        *ngIf="recipe?.DisplayAmountText?.trim()?.length "
        [ngStyle]="{
          color: RecipePriceTextColor,
          border: '1px solid ' + RecipePriceBorderColor,
          'background-color': RecipePriceBackgroundColor
        }"
      >
        {{ recipe?.DisplayAmountText }}
      </span>
      <span
        *ngIf="recipe.RecipeStock && addTocart && !recipe.isAddedToCart"
        (click)="getRecipeModal(recipe)"
        class="cursor-pointer"
        [title]="recipe.RecipeTitle + ' Add to Cart'"
      >
        <i
          class="fas fa-plus-square"
          [ngStyle]="{ color: MenuCartColor }"
          aria-hidden="true"
          style="font-size: xx-large"
          [title]="recipe.RecipeTitle + ' Add to Cart'"
        ></i>
      </span>
      <span
        *ngIf="recipe?.RecipeExtraObject && dineIn"
        (click)="getRecipeModal(recipe)"
        class="cursor-pointer"
      >
        <button
          type="button"
          class="btn br-40px"
          [ngStyle]="{
            'background-color': SelectedButtonColor,
            color: SelectedButtonTextColor
          }"
        >
          Options
        </button>
      </span>
    </div>
  </div>
</div>

<ngx-spinner
  bdColor="rgba(51, 51, 51, 0.8)"
  size="large"
  color="#dc3545"
  type="ball-scale-multiple"
>
</ngx-spinner>

<app-popup *ngIf="showPopup"></app-popup>
